import styled from "@emotion/styled";

export const ButtonWrapper = styled.div(() => ({
    display: "inline-block",
}));
